import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { HeaderContainer } from '../../header/headerContainer';
import { HeaderTitle } from '../../header/headerTitle';
import { RightPanelControls } from '../../panels/rightPanelControls';
import { LobbyDrawerControl } from './drawer/lobbyDrawerControl';
export const LobbyHeaderBar = () => {
    return (_jsxs(HeaderContainer, { children: [_jsx(LobbyDrawerControl, {}), _jsx(HeaderTitle, { title: 'TRIPLEJACK', subTitle: 'LOBBY' }), _jsx(RightPanelControls, {})] }));
};
